export default [
    {
        id: 1,
        name_ca: 'Punt alt',
        name_es: 'Punto alto',
        name_en: 'High point'
    }, {
        id: 2,
        name_ca: 'Punt mig',
        name_es: 'Punto medio',
        name_en: 'Middle point'
    }, {
        id: 3,
        name_ca: 'Punt baix',
        name_es: 'Punto bajo',
        name_en: 'Low point'
    }
]



// WEBPACK FOOTER //
// ./src/options/conjunctures.js